module.exports = __webpack_public_path__ + "img/Coin BankC02.1ac28f94.png";